<mat-horizontal-stepper linear="false" #stepper (selectionChange)="changeStepper($event, stepper)">
  <mat-step [completed]="isFirstStepCompleted" [hasError]="firstStepError" class="d-print-adjust">
    <ng-template matStepLabel>{{ 'request.matStepLabel1' | translate }}</ng-template>
    <scf-point-of-sale
      [mode]="mode"
      [request]="request"
      (vendor)="updateCombosVendor($event)"
      [state]="state"
      [isMG]="false"
      [isMgWithShopping]="false"
      [isBP]="false"
      [operative]="operative"
      (changeContinueStatus)="changeContinueStatusForms($event)"
      (establishment)="updateCombos($event)"
      (isFinishedLoading)="changeContinueLoadingStatus($event)"
      (typeBalance)="updateBalance($event)"
    ></scf-point-of-sale>

    <scf-prescriber-contact-data
      [mode]="mode"
      [request]="request"
      [state]="state"
      [vendor]="vendor"
      [operative]="operative?.value"
      (isFinishedLoading)="changeContinueLoadingStatus($event)"
      (changeContinueStatus)="changeContinueStatusForms($event)"
    >
    </scf-prescriber-contact-data>

    <scf-financing-amount
      [mode]="mode"
      [request]="request"
      [requestOperative]="operative?.value"
      [state]="state"
      [typeBalance]="typeBalance"
      [maxAmount]="maxAmount"
      [markTouched]="markTouched"
      [establishment]="establishment"
      [isDisableCalculateButton]="isDisableCalculateButton"
      (changeContinueStatus)="changeContinueStatusForms($event)"
      (sendDataFinance)="openCalculateFinance($event)"
      (isFinishedLoading)="changeContinueLoadingStatus($event)"
      (sendOperative)="updateOperative($event)"
      (sendProductLine)="updateSelectedProductLine($event)"
      (sendPriceProduct)="updatePriceProduct($event)"
      (sendRequestedAmount)="updateRequestedAmount($event)"
      (sendStart)="updateStart($event)"
    >
    </scf-financing-amount>
    <scf-request-data-uptake
      *ngIf="
        (typeBalance?.balance === 'S' && operative?.value !== null) ||
        typeBalance?.balance !== 'S' ||
        this.mode === 'view'
      "
      [mode]="mode"
      [request]="request"
      [state]="state"
      [establishment]="establishment"
      [vendor]="vendor"
      [isLoadingFinance]="isLoadingFinance"
      [expirationMonth]="expirationMonth"
      [operative]="operative"
      [isDisableSendClientButton]="isDisableSendClientButton"
      [selectedProductLine]="selectedProductLine"
      [requestedAmount]="requestedAmount"
      [priceProduct]="priceProduct"
      [start]="start"
      (maxAmount)="updateMaxAmount($event)"
      (changeContinueStatus)="changeContinueStatusForms($event)"
      (sendDataFinance)="openCalculateFinance($event)"
      (isFinishedLoading)="changeContinueLoadingStatus($event)"
    >
    </scf-request-data-uptake>
    <scf-request-finance
      *ngIf="
        ((typeBalance?.balance === 'S' && operative?.value !== null) || typeBalance?.balance !== 'S') && mode !== 'view'
      "
      [establishment]="establishment"
      [mode]="mode"
      [operative]="operative?.value"
      [request]="request"
      [dataCallSimulation]="dataFinance"
      [changing]="changingValueClearTable"
      (changeContinueStatus)="changeContinueStatusForms($event)"
      (loading)="isLoadingFinance = $event"
      (isFinishedLoading)="changeContinueLoadingStatus($event)"
      (changeExpiredMonth)="getExpiredMonth($event)"
    ></scf-request-finance>

    <scf-request-basic-contact
      *ngIf="showBasicContactData()"
      [operative]="operative?.value"
      [mode]="mode"
      [state]="state"
      [request]="request"
      (sendToClient)="sendToClient()"
      (changeContinueStatus)="changeContinueStatusForms($event)"
      (isFinishedLoading)="changeContinueLoadingStatus($event)"
    ></scf-request-basic-contact>

    <div class="row" class="btnActions">
      <div class="btnLeft d-print-none">
        <button
          id="clearFieldsFirstStepButtonRequest"
          *ngIf="mode === 'new' || (mode === 'edit' && state?.id === '00')"
          mat-stroked-button
          color="accent"
          (click)="clearFields()"
        >
          {{ 'request.buttonReset' | translate | uppercase }}
        </button>
      </div>
      <div class="btnRight d-print-none">
        <button
          id="saveFirstStepButtonRequest"
          *ngIf="(mode === 'new' || (mode === 'edit' && state?.id === '00')) && operative?.value === 'ESC'"
          mat-stroked-button
          color="accent"
          (click)="openDialogPassword('save')"
        >
          <mat-icon class="icon-ic_save"></mat-icon> {{ 'request.buttonSave' | translate | uppercase }}
        </button>
        <button
          id="nextStepFirstStepButtonRequest"
          mat-flat-button
          color="accent"
          [disabled]="stepDisabled"
          matStepperNext
        >
          {{ 'request.matStepperNext' | translate | uppercase }}
        </button>
      </div>
    </div>
  </mat-step>

  <mat-step
    [aria-labelledby]="stepDisabled ? 'disabled_step' : null"
    [completed]="isSecondStepCompleted"
    [hasError]="secondStepError"
    [state]="stepDisabled ? 'noNumber' : 'number'"
  >
    <ng-template matStepLabel>{{ 'request.matStepLabel2' | translate }}</ng-template>
    <scf-holder-data
      [mode]="mode"
      [request]="request"
      [state]="state"
      [operative]="operative?.value"
      (changeContinueStatus)="changeContinueStatusForms($event)"
      (isFinishedLoading)="changeContinueLoadingStatus($event)"
    ></scf-holder-data>
    <scf-contact-data
      [mode]="mode"
      [request]="request"
      [state]="state"
      [isAuto]="false"
      [isConsumption]="true"
      [operative]="operative?.value"
      (changeContinueStatus)="changeContinueStatusForms($event)"
      (isFinishedLoading)="changeContinueLoadingStatus($event)"
    ></scf-contact-data>
    <scf-socioeconomic-data
      [mode]="mode"
      [request]="request"
      [state]="state"
      [isMG]="false"
      [isMgWithShopping]="false"
      [isBP]="false"
      [isConsumo]="true"
      [isRepsol]="isRepsol"
      [isGS]="isGS"
      [operative]="operative?.value"
      (changeContinueStatus)="changeContinueStatusForms($event)"
      (isFinishedLoading)="changeContinueLoadingStatus($event)"
    >
    </scf-socioeconomic-data>
    <div class="btnLeft">
      <button
        id="addIntervinentRequest"
        class="request__interviniente request__btnIntervinientes--add"
        color="primary"
        mat-flat-button
        (click)="addIntervinente(1)"
        *ngIf="this.intervinientes.length === 0 && !isRepsol && !isCrediCuenta && !isGS && mode !== 'view'"
      >
        <mat-icon class="icon-ic_add_circle_outline"></mat-icon>
        <mat-label [translate]="'request.addIntervinent'"> </mat-label>
      </button>
    </div>
    <!-- INTERVINIENTES -->
    <div *ngFor="let interviniente of intervinientes; let i = index; let last = last">
      <div class="btnLeft">
        <button
          id="deleteIntervinentButtonRequest"
          class="request__interviniente request__btnIntervinientes--delete"
          color="primary"
          mat-stroked-button
          (click)="deleteInterviniente(interviniente)"
          *ngIf="
            !isRepsol &&
            !isGS &&
            mode !== 'view' &&
            (state?.id === PENDIENTES_DE_DATOS || mode === 'new' || request?.participants.length === 0)
          "
        >
          <mat-icon class="icon-ic_remove_circle_outline"></mat-icon>
          <mat-label [translate]="'request.deleteIntervinent'"> </mat-label>
        </button>
      </div>

      <div>
        <scf-holder-data
          [mode]="mode"
          [request]="interviniente.request"
          [state]="state"
          [interviniente]="interviniente"
          [operative]="operative?.value"
          (changeContinueStatus)="changeContinueStatusForms($event)"
        ></scf-holder-data>
        <scf-contact-data
          [mode]="mode"
          [request]="interviniente.request"
          [state]="state"
          [interviniente]="interviniente"
          [isAuto]="false"
          [isConsumption]="true"
          [operative]="operative?.value"
          (changeContinueStatus)="changeContinueStatusForms($event)"
        >
        </scf-contact-data>
        <scf-socioeconomic-data
          [interviniente]="interviniente"
          [isMgWithShopping]="false"
          [state]="state"
          [isBP]="false"
          [isMG]="false"
          [isAuto]="false"
          [isConsumo]="true"
          [isRepsol]="isRepsol"
          [isGS]="isGS"
          [mode]="mode"
          [request]="interviniente.request"
          (changeContinueStatus)="changeContinueStatusForms($event)"
          [operative]="operative?.value"
        ></scf-socioeconomic-data>
      </div>
    </div>
    <div class="row" class="btnActions">
      <div class="btnLeft">
        <button id="previousStepSecondStepRequest" mat-flat-button color="accent" matStepperPrevious>
          {{ 'request.matStepperPrevious' | translate | uppercase }}
        </button>
        <button
          id="clearFieldsSecondStepRequest"
          *ngIf="mode === 'new' || (mode === 'edit' && state?.id === '00')"
          mat-stroked-button
          color="accent"
          (click)="clearFields()"
        >
          {{ 'request.buttonReset' | translate | uppercase }}
        </button>
      </div>
      <div class="btnRight">
        <button
          id="saveButtonSecondStepRequest"
          *ngIf="(mode === 'new' || (mode === 'edit' && state?.id === '00')) && operative?.value === 'ESC'"
          mat-stroked-button
          color="accent"
          (click)="openDialogPassword('save')"
        >
          <mat-icon class="icon-ic_save"></mat-icon> {{ 'request.buttonSave' | translate | uppercase }}
        </button>
        <button id="nextStepSecondStepRequest" mat-flat-button color="accent" [disabled]="stepDisabled" matStepperNext>
          {{ 'request.matStepperNext' | translate | uppercase }}
        </button>
      </div>
    </div>
  </mat-step>

  <mat-step
    [aria-labelledby]="stepDisabled ? 'disabled_step' : null"
    [completed]="isThirdStepCompleted"
    [hasError]="thirdStepError"
    [state]="stepDisabled ? 'noNumber' : 'number'"
  >
    <ng-template matStepLabel>{{ 'request.matStepLabel3' | translate }}</ng-template>
    <scf-direct-debit
      [mode]="mode"
      [request]="request"
      [state]="state"
      [operative]="operative?.value"
      (changeContinueStatus)="changeContinueStatusForms($event)"
      (isFinishedLoading)="changeContinueLoadingStatus($event)"
    >
    </scf-direct-debit>
    <!-- INTERVINIENTES -->
    <div *ngFor="let interviniente of intervinientes; let i = index; let last = last">
      <scf-direct-debit
        [interviniente]="interviniente"
        [mode]="mode"
        [state]="state"
        [request]="interviniente.request"
        [operative]="operative?.value"
        (changeContinueStatus)="changeContinueStatusForms($event)"
      ></scf-direct-debit>
    </div>
    <scf-request-observations
      [mode]="mode"
      [observations]="request?.observations"
      [request]="request"
      [state]="state"
      [requestType]="isRepsol ? 'RP' : isGS ? 'GS' : 'C'"
      [operative]="operative?.value"
      (changeContinueStatus)="changeContinueStatusForms($event)"
      (isFinishedLoading)="changeContinueLoadingStatus($event)"
    >
    </scf-request-observations>
    <p class="terminos">
      {{ 'request.agreementPersonalData' | translate }}
    </p>
    <div class="row" class="btnActions">
      <div class="btnLeft">
        <button id="previousStepThirdStepRequest" mat-flat-button color="accent" matStepperPrevious>
          {{ 'request.matStepperPrevious' | translate | uppercase }}
        </button>
        <button
          id="nextStepThirdStepRequest"
          *ngIf="mode === 'new' || (mode === 'edit' && state?.id === '00')"
          mat-stroked-button
          color="accent"
          (click)="clearFields()"
        >
          {{ 'request.buttonReset' | translate | uppercase }}
        </button>
      </div>
      <div class="btnRight">
        <button
          id="printRequest"
          *ngIf="(mode === 'new' || (mode === 'edit' && state?.id === '00')) && !isRepsol && !isGS"
          mat-stroked-button
          color="accent"
          (click)="openDialogPassword('print')"
        >
          <mat-icon class="icon-ic_print"></mat-icon> {{ 'request.buttonPrintContract' | translate | uppercase }}
        </button>
        <button
          id="saveButtonThirdStepRequest"
          *ngIf="(mode === 'new' || (mode === 'edit' && state?.id === '00')) && operative?.value === 'ESC'"
          mat-stroked-button
          color="accent"
          (click)="openDialogPassword('save')"
        >
          <mat-icon class="icon-ic_save"></mat-icon> {{ 'request.buttonSave' | translate | uppercase }}
        </button>
        <button
          id="sendButtonRequest"
          *ngIf="mode !== 'view'"
          mat-flat-button
          color="accent"
          (click)="openDialogPassword('send')"
          [disabled]="!enviarPeticion"
        >
          {{ 'request.buttonSend' | translate | uppercase }} <mat-icon class="icon-ic_send"></mat-icon>
        </button>
      </div>
    </div>
  </mat-step>
  <ng-template matStepperIcon="error">
    <mat-icon class="icon-ic_error_warnning"></mat-icon>
  </ng-template>
</mat-horizontal-stepper>
